import { Box, Typography } from "@mui/material";
import NumberFormats from "components/NumberFormats";
import { DefaultUrlWeb } from "config/Configuration";
import React from "react";

function Amount({ data }) {
  return (
    <Box display="flex" alignItems="center">
      <img
        src={DefaultUrlWeb + data?.coinImageUrl}
        alt=""
        width={25}
        height={25}
      />
      <Typography variant="h6" color="text.main" pl={1}>
        <Typography variant="h6">
          <NumberFormats value={data?.amount} /> <Typography variant="subtitle1" color="text.secondary" component="span">{data?.coinName}</Typography>
        </Typography>
      </Typography>
    </Box>
  );
}

export default Amount;
